export const HERO_CONSTANTS = {
  button: {
    label: "Secure your storage infrastructure today",
    link: "#contact-us",
  },
  content:
    "Protect mission-critical workloads with Encrypted Storage Clusters, ensuring data security, redundancy, and compliance.",
  title: "Secure & Resilient Storage for Sensitive Data",
};
